import { render, staticRenderFns } from "./DashboardOverview.vue?vue&type=template&id=27848666&scoped=true&"
import script from "./DashboardOverview.vue?vue&type=script&lang=js&"
export * from "./DashboardOverview.vue?vue&type=script&lang=js&"
import style0 from "./DashboardOverview.css?vue&type=style&index=0&id=27848666&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27848666",
  null
  
)

export default component.exports